export type AetUserContext = {
  userPrincipalName: string;
  externalUserId: string;
  additionalSupplierCodes: string;
  additionalLpCode: string;
  additionalNAMC: string;
  additionalDomicile: string;
  firstName: string;
  lastName: string;
  email: string;
  displayName: string;
  roles: string[];
  isAdmin: boolean;
  userId: string;
};

function getFgaFromSession(): any {
  try {
    return JSON.parse(sessionStorage.getItem('FGA'));
  } catch {
    return null;
  }
}

export function buildAetUserContext(): AetUserContext {
  const fgaDetails = getFgaFromSession();
  const userAttributes = fgaDetails?.user?.applicationUserAttribute?.[0]?.userAttributes ?? [];
  const getAttr = (key: string) => userAttributes.find((a: any) => a.key === key)?.value ?? null;
  const roles = (fgaDetails?.roles ?? []).map((r: any) => r.displayName);

  return {
    userPrincipalName: fgaDetails?.user?.userPrincipalName ?? null,
    externalUserId: fgaDetails?.user?.externalUserId ?? null,
    additionalSupplierCodes: getAttr('additionalSupplierCodes'),
    additionalLpCode: getAttr('additionalLpCode'),
    additionalNAMC: getAttr('additionalNAMC'),
    additionalDomicile: getAttr('additionalDomicile'),
    firstName: fgaDetails?.user?.firstName ?? null,
    lastName: fgaDetails?.user?.lastName ?? null,
    email: fgaDetails?.user?.email ?? null,
    displayName: fgaDetails?.user?.displayName ?? null,
    roles,
    isAdmin: roles.includes('AET Admin'),
    userId: fgaDetails?.user?.userId ?? null,
  };
}

export function getPreferredUserIdentifier(fallback?: string): string {
  const context = buildAetUserContext();
  return context.userPrincipalName || context.email || fallback || '';
}
